import { render, staticRenderFns } from "./NewIcrea.vue?vue&type=template&id=b6dfc638&"
import script from "./NewIcrea.vue?vue&type=script&lang=js&"
export * from "./NewIcrea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports